module.exports = __webpack_public_path__ + "media/newstyle/images/ajustes2-9b2cbb80a9128ccf86f3d380f738a7ed.png";